import { InjectionToken } from '@angular/core';

// Notifica ai componenti che la sync è stata completata (anche in caso di errore)
export const SYNC_TOKEN = new InjectionToken<boolean>('SYNC');
